import {
    GETCOMMONCONFIGURATIONDETAILSADMIN_SUCCESS,
    GETCOMMONCONFIGURATIONDETAILSADMIN_FAILED,
    RESET_GETCOMMONCONFIGURATIONDETAILSADMIN,
    LOADING_GETCOMMONCONFIGURATIONDETAILSADMIN,
    NETWORK_GETCOMMONCONFIGURATIONDETAILSADMIN
} from '../types/index';

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETCOMMONCONFIGURATIONDETAILSADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETCOMMONCONFIGURATIONDETAILSADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETCOMMONCONFIGURATIONDETAILSADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_GETCOMMONCONFIGURATIONDETAILSADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETCOMMONCONFIGURATIONDETAILSADMIN:
            return (state = initialState);
        default:
            return state;
    }
};